import ReactGA from "react-ga4";
interface GaService {
  searchInput: (value: string) => void;
  searchSuggestionClick: (value: string) => void;
  chartInteraction: (chartName: string, conversationId?: string) => void;

  shareNow: () => void;
  shareNowWA: () => void;
  shareNowFB: () => void;
  shareNowLI: () => void;
  shareNowX: () => void;
  shareNowCopyLink: () => void;

  ratings: (rating: number) => void;
  feedback_submit: () => void;
  feedback_input: (value: string) => void;
  feedback_suggestions: (value: string) => void;

  logoClicked: () => void;

  voiceInputStarted: () => void;
  voiceInputSubmited: () => void;
  voiceInputReset: () => void;

  googleLoginClicked: () => void;
  downloadReport: () => void;
  cityChanged: (value: string) => void;

  stateChanged: (value: string) => void;
  categoryChanged: (value: string) => void;
  dateRangeChanged: (value: string) => void;
  navBarSelection: (value: string, gaTitle: string) => void;
  gaClickOnGeoTrendsDownload: (value: string) => void;

  // 🔽 new conversational events
  conversationStarted: () => void; // ✅ no conversation_id
  conversationUserMessage: (message: string, conversationId: string) => void;
  conversationAIResponse: (
    responseType: string,
    isFallback: "yes" | "no",
    conversationId: string
  ) => void;
  conversationSuggestedPromptClicked: (
    promptText: string,
    source: "new_chat" | "followup_chat"
  ) => void;
  conversationHistoryOpened: (conversationId: string) => void;
  chatFeedback: (
    messageId: string,
    feedbackValue: "like" | "dislike",
    hasSuggestion: true|false
  ) => void;
  chatFeedbackLike: (messageId: string, hasSuggestion?: string) => void;
  chatFeedbackDislike: (messageId: string, hasSuggestion?: string) => void;
}


export function initializeGA4() {
  // const gaId = process.env.NEXT_PUBLIC_GA_ID;

  // TagManager.initialize({
  //   gtmId: "GTM-T725ZQKP",
  // });

  ReactGA.initialize("G-RJQPGT8FXC" as string);
  // } else {
  //   console.error("Google Analytics ID is undefined. Make sure it is set in your environment variables.");
  // }
}

function sendEventToGA(
  cat: string,
  action: string,
  label: string,
  value?: unknown
) {
  console.log("🚀 ~ sendEventToGA ~ cat:", cat)
  ReactGA.event({
    category: cat,
    action: action,
    label: label + value,
    // params: value,
  });
  // try {
  //   const datalayer = (window as unknown).dataLayer;
  //   datalayer.push({
  //     event: "event",
  //     eventProps: {
  //       category: cat,
  //       action: action,
  //       label: label,
  //       value: value,
  //     },
  //   });
  // } catch (e) {
  //   console.log(e);
  // }
}

const gaService: GaService = {
  searchInput: (value) =>
    sendEventToGA("Search", "Input", "Enter Search", value),
  searchSuggestionClick: (value) =>
    sendEventToGA(
      "Search",
      "Auto-suggestion Click",
      "Suggestion Selected",
      value
    ),
  chartInteraction: (chartName) => null,
    // sendEventToGA("Charts", "Chart Interaction", "Hover Over Chart", chartName),
  shareNow: () =>
    sendEventToGA("Button Clicks", "Share Now Button", "share", ""),
  shareNowWA: () =>
    sendEventToGA("Button Clicks", "Share on Whatsapp", "share_wa", ""),
  shareNowFB: () =>
    sendEventToGA("Button Clicks", "Share on Facebook", "share_facebook", ""),
  shareNowLI: () =>
    sendEventToGA("Button Clicks", "Share LinkedIn", "share_linkedin", ""),
  shareNowX: () => sendEventToGA("Button Clicks", "Share on X", "share_x", ""),
  shareNowCopyLink: () =>
    sendEventToGA("Button Clicks", "Share by copy link", "share_copylink", ""),
  ratings: (rating: number) =>
    sendEventToGA(
      "Button Clicks",
      `Feedback_${rating}`,
      `feedback_${rating}`,
      ""
    ),
  feedback_submit: () =>
    sendEventToGA("Button Clicks", "Feedback Submit", "feedback_submit", ""),
  feedback_input: (value: string) =>
    sendEventToGA("Feedback", "Feedback Textbox", "edit_feedback", value),
  feedback_suggestions: (value: string) =>
    sendEventToGA(
      "Feedback",
      "Feedback Suggestions",
      "suggested_feedback",
      value
    ),
  logoClicked: () =>
    sendEventToGA("Logo", "Select Shiprocket Trends Logo", "select_logo", ""),
  voiceInputStarted : ()=> sendEventToGA("Voice", "Voice input clicked", "voice_started", ""),
  voiceInputSubmited : ()=> sendEventToGA("Voice", "Voice input submitted", "voice_input_submit", ""),
  voiceInputReset : ()=> sendEventToGA("Voice", "Voice input reset", "voice_input_reset", ""),
  googleLoginClicked : ()=> sendEventToGA("Login", "Login started", "login_Started", ""),
  downloadReport : () => sendEventToGA("Button Clicks", "Download Report", "download_report", ""),

  cityChanged: (value : string) =>
    sendEventToGA(
      "Filters",
      "City Suggestion changed",
      "City Suggested",
      value
    ),
  stateChanged: (value) =>
    sendEventToGA(
      "Filters",
      "State Suggestion changed",
      "State Suggested",
      value
    ),
  categoryChanged: (value) =>
    sendEventToGA("Filters", "Category changed", "Filter Category", value),
  dateRangeChanged: (value) =>
    sendEventToGA("Filters", "Date Range changed", "Filter Date Range", value),

  navBarSelection: (value, gaTitle) =>
    sendEventToGA("Nav Bar", "Selected " + value, "select_" + gaTitle, ""),

  gaClickOnGeoTrendsDownload : (value:string) =>
    sendEventToGA("Geo Trends", "Click on download" + value,  "click_on_download_" + value),

  conversationStarted: () =>
    sendEventToGA(
      "Conversation",
      "Conversation Started",
      "conversation_started"
    ),

  // 2) User Message Sent
  conversationUserMessage: (message, conversationId) =>
    sendEventToGA(
      "Conversation",
      "User Message Sent",
      "conversation_user_message",
      `${conversationId} | ${message}`
    ),

  // 3) AI Response Generated
  conversationAIResponse: (responseType, isFallback, conversationId) =>
    sendEventToGA(
      "Conversation",
      "AI Response Generated",
      "conversation_ai_response",
      `${conversationId} | type:${responseType} | fallback:${isFallback}`
    ),

  // 4) Suggested Prompt Clicked
  conversationSuggestedPromptClicked: (promptText, source) =>
    sendEventToGA(
      "Conversation",
      "Suggested Prompt Clicked",
      "conversation_suggested_prompt_clicked",
      `${source} | ${promptText}`
    ),

  // 5) Previous Conversation Opened
  conversationHistoryOpened: (conversationId) =>
    sendEventToGA(
      "Conversation",
      "Conversation History Opened",
      "conversation_history_opened",
      conversationId
    ),
  chatFeedback : (messageId, feedbackValue, hasSuggestion) =>
    sendEventToGA(
      "Conversation",
      "Chat Feedback Submitted",
      "conversation_feedback_submitted",
      `${messageId} | feedback:${feedbackValue} | suggestion:${hasSuggestion}`
    ),

    chatFeedbackLike: (messageId, hasSuggestion) =>
      sendEventToGA(
        "Conversation",
        "Chat Feedback Like",
        "conversation_feedback_like",
        `${messageId} | suggestion:${hasSuggestion}`
      ),
    chatFeedbackDislike: (messageId, hasSuggestion) =>
      sendEventToGA(
        "Conversation",
        "Chat Feedback Dislike",
        "conversation_feedback_dislike",
        `${messageId} | suggestion:${hasSuggestion}`
      ),
};

export default gaService;
